import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import type { IRenewalTemplateTabProps } from '@/@types/insurance';

export function RenewalCompanyEmailTemplateTab({
  template,
  onTemplateChange,
  availableVariables,
}: IRenewalTemplateTabProps) {
  const insertVariable = (variable: string) => {
    onTemplateChange(template + `{{${variable}}}`);
  };

  return (
    <div className="space-y-4 py-4">
      <div className="space-y-1">
        <Label htmlFor="company-email-template">Company admin email template</Label>
        <p className="text-xs text-muted-foreground">
          Sent to the company admin when their employees have policies expiring.
          Use{' '}
          <code className="text-xs bg-muted px-1 rounded">{'{{employeeList}}'}</code>{' '}
          to insert the list of affected employees.
        </p>
      </div>

      <div className="flex flex-wrap gap-1.5">
        {availableVariables.map(variable => (
          <Button
            key={variable}
            type="button"
            variant="outline"
            size="sm"
            onClick={() => insertVariable(variable)}
            className="h-7 px-2 text-xs font-mono"
          >
            {`{{${variable}}}`}
          </Button>
        ))}
      </div>

      <Textarea
        id="company-email-template"
        value={template}
        onChange={e => onTemplateChange(e.target.value)}
        rows={12}
        placeholder="Enter company email template..."
        className="font-mono text-sm resize-y"
        maxLength={5000}
      />

      <p className="text-xs text-muted-foreground text-right">
        {template.length} / 5000 characters
      </p>
    </div>
  );
}
